import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export const AIInteractionTypeEnum = schemas.InteractionTypeB42Enum.enum
export type VoiceAICallInfo = z.infer<typeof schemas.VoiceAICallInfo>
export type AIPhoneLine = z.infer<typeof schemas.AIPhoneLine>
export type AITestQuestion = z.infer<typeof schemas.AITestQuestion>
export type AITestQuestionId = z.infer<typeof schemas.AITestQuestionIdField>
export type DifficultyEnum = z.infer<typeof schemas.DifficultyEnum>
